module.exports = __webpack_public_path__ + "img/amazon-logo.ec5df551.svg";